import { ValidationResult } from "sprint-common-web";

import { ContentVersion } from "../../../../common/types/ContentReference";

export interface ContentAssociationValidation {
    rules: ContentAssociationValidationRules;
    actions?: ContentAssociationValidationActions;
}

interface ContentAssociationValidationActions {
    validateVersions?: (versions: ContentVersion[], versionIds?: string[]) => ValidationResult;
}

export interface ContentAssociationValidationRules {
    isTitleRequired: boolean;
    isSeasonRequired: boolean;
    isEpisodeRequired: boolean;
    areVersionsRequired: boolean;
    isAirlineRequired: boolean;
}

const defaultContentAssociationRules: ContentAssociationValidationRules = {
    isTitleRequired: true,
    isSeasonRequired: true,
    isEpisodeRequired: true,
    areVersionsRequired: true,
    isAirlineRequired: true
};

export const defaultContentAssociationValidation: ContentAssociationValidation = {
    rules: defaultContentAssociationRules
};
